<template>
  <div class="database-setting-modal">
    <CustomModal @onClose="close">
      <div class="database-setting-content-wrapper">
        <div class="content">
          <h3 class="content-title">
            Datenbank <b>{{ database.caption }}</b> Einstellungen
          </h3>

          <form @submit.prevent="onSaveDatabaseSettings">
            <div class="form-element d-flex justify-content-between">
              <p>
                Soll vor dem Löschen eines Datenbankeintrags eine Bestätigung
                angefragt werden ?
              </p>
              <CommonSwitch
                class="common-switch"
                v-model="confirmDelete"
                :isDisabled="database.add_only"
              ></CommonSwitch>
            </div>

            <div class="form-element d-flex justify-content-between">
              <p>Sekunden in Datumsanzeige einblenden?</p>
              <CommonSwitch
                class="common-switch"
                v-model="showSeconds"
                :isDisabled="database.add_only"
              ></CommonSwitch>
            </div>

            <CommonButton
              @onClick="onSaveDatabaseSettings"
              :isLoading="isLoadingSaveButton"
              class="common-button-component"
              type="button"
              :isDisabled="database.add_only"
              >speichern</CommonButton
            >
          </form>
        </div>
      </div>
    </CustomModal>
  </div>
</template>

<script>
import CustomModal from './CustomModal.vue';
import CommonButton from '../widgets/CommonButton.vue';
import CommonSwitch from '../widgets/CommonSwitch.vue';
import { updateTableSchema } from '../../services/userTable';

export default {
  name: 'DatabaseSetting',
  props: {
    database: { type: Object, required: true },
  },
  data() {
    return {
      confirmDelete: false,
      isLoadingSaveButton: false,
      showSeconds: false,
    };
  },
  methods: {
    close() {
      this.$emit('close');
    },
    async onSaveDatabaseSettings() {
      try {
        this.isLoadingSaveButton = true;
        const formDataForConfrimDelete = new FormData();
        const formDataForSeconds = new FormData();
        formDataForConfrimDelete.append('value', this.confirmDelete);
        formDataForSeconds.append('value', this.showSeconds);
        if (
          this.database.confirmDelete === undefined ||
          JSON.parse(this.database.confirmDelete) !== this.confirmDelete
        ) {
          await updateTableSchema(
            this.user,
            this.database.name,
            formDataForConfrimDelete,
            'confirmDelete'
          );
        }
        if (
          this.database.showSeconds === undefined ||
          JSON.parse(this.database.showSeconds) !== this.showSeconds
        ) {
          await updateTableSchema(
            this.user,
            this.database.name,
            formDataForSeconds,
            'showSeconds'
          );
        }
        this.$emit(
          'updateDatabaseSetting',
          this.database.name,
          this.confirmDelete,
          this.showSeconds
        );
        this.close();
      } catch (error) {
      } finally {
        this.isLoadingSaveButton = false;
      }
    },
    setConfirmDeleteAndShowSeconds() {
      if (
        !this.database.hasOwnProperty('confirmDelete') ||
        this.database.confirmDelete === null
      ) {
        this.confirmDelete = true;
      } else {
        this.confirmDelete = JSON.parse(this.database.confirmDelete);
      }
      if (
        !this.database.hasOwnProperty('showSeconds') ||
        this.database.showSeconds === null
      ) {
        this.showSeconds = true;
      } else {
        this.showSeconds = JSON.parse(this.database.showSeconds);
      }
    },
  },
  created() {
    this.setConfirmDeleteAndShowSeconds();
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },

  components: {
    CustomModal,
    CommonButton,
    CommonSwitch,
  },
};
</script>

<style scoped>
.database-setting-modal .database-setting-content-wrapper {
  height: 364px;
  max-width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.database-setting-modal .database-setting-content-wrapper .content {
  width: 65%;
  max-width: 100%;
  height: fit-content;
}
@media (max-width: 767px) {
  .database-setting-modal .database-setting-content-wrapper .content {
    width: 100%;
    max-width: 100%;
    height: auto;
    padding: 0 50px;
  }
}

.database-setting-modal .content-title {
  font-size: 20px;
  color: #333343;
  margin: 0;
  font-weight: 400;
  text-transform: uppercase;
}
.database-setting-modal .form-element {
  margin-top: 20px;
}
.database-setting-modal .form-element p {
  font-size: 16px;
  margin: 0;
  text-wrap: wrap !important;
}
.database-setting-modal .common-button-component {
  margin-top: 27px;
}
.database-setting-modal .common-switch {
  margin-top: 6px;
}
</style>
